export class JourneyPath {
  id: number;
  price_sheet_id: number;
  name: string;
  // The population this group's items price. Always set on a live group —
  // one group per population, contract-wide (MPN-1592); null only on history.
  population_segment_id: number | null;

  constructor(data: any) {
    this.id = data.id;
    this.price_sheet_id = data.price_sheet_id;
    this.name = data.name ?? "";
    this.population_segment_id = data.population_segment_id ?? null;
  }
}
